/**
 * A file that's been attached to a line item for a transcript
 */
export class OrderAttachmentRequest {
}
